import { Component, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LineLovDialogComponent } from '../../common/line-lov-dialog/line-lov-dialog.component';
import { IssSrcComponent } from '../../common/iss-src/iss-src.component';
import { PerilLovComponent } from '../../common/peril-lov/peril-lov.component';
import { ContractTypeLovDialogComponent } from '../../common/contract-type-lov/contract-type-lov.component';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { DialogBoxService } from 'src/app/services/dialog-box.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { forkJoin, Observable } from 'rxjs';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { SecurityService } from 'src/app/services/security.service'; 
@Component({
  selector: 'deductible-maintenance',
  templateUrl: './deductible-maintenance.component.html',
  styleUrls: ['./deductible-maintenance.component.css']
})
export class DeductibleMaintenanceComponent implements OnInit, LeaveConfirmation {
  
  datePipe = new DatePipe('en-us');

  addDisabled : boolean = false;
  saveDisabled : boolean = true;
  deleteDisabled : boolean = true;
  tranPosted : boolean = false;
  noLoadingInProcess : boolean = true;
  validated : boolean = false;
  userIDReadOnly : boolean = false;
  isLineSelected : boolean = false;
  pubUserStdRatesCodeField: string = '';
  currentUser: string = this.jsonDataService.retrieveFromStorage('userId');
  rowClickedData: any;
  selectedData : any = null;
  moduleId: string = 'BMM137';
  perilDisabled: boolean = true;
  moduleName: string = '';
  selectedLine: any = {
    LINE_CD: '',
    LINE_NAME: '',
    LINE_FIELD: ''
  };

  selectedSubline: any = {
    SUBLINE_CD: '',
    SUBLINE_NAME: '',
    SUBLINE_FIELD: ''
  };

  tempAddedData: any = [];
  tempUpdateData: any = [];
  deductibleTypeList: any = [];
  rangeSwitchList: any = [];

  paramForm = this.formBuilder.group({
    lineCd: [null],
    lineName: [null],
    lineField: [null],
    sublineCd: [null],
    sublineNaeCdme: [null],
    sublineField: [null],
  });
  deductibleForm = this.formBuilder.group({
    deductibleCd: [null, [Validators.required, Validators.maxLength(5)]],
    deductibleTitle: [null, [Validators.maxLength(30)]],
    deductibleText: [null],
    deductibleType: [null],
    deductibleRate: [null, [Validators.maxLength(13)]],
    activeTag: ['A', [Validators.required]],
    deductibleAmt: [null, [Validators.maxLength(17)]],
    minAmt: [null, [Validators.maxLength(17)]],
    maxAmt: [null, [Validators.maxLength(17)]],
    rangeSwitch:[null],
    remarks: [null],
    userID: [null],
    lastUserUpdate: [null]
  });

  constructor(
    private apiCallService: APICallService,
    public _Dialog: MatDialog, 
    private userDetailService: UserDetailsService,
    private formService: FormService, 
    private formBuilder: FormBuilder, 
    private appMessageService: AppMessageService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService
  ) {  
    let moduleLists = JSON.parse(this.jsonDataService.decrypt(sessionStorage.getItem("mdls") || "")); 
    this.moduleName = moduleLists.filter((data: any) => { return data.moduleId === this.moduleId })[0].moduleDesc.toUpperCase();
    this.deductibleTypeList = this.jsonDataService.data.refCds.filter((e: any) => e.rvDomain=="DEDUCTIBLE_TYPE");
    this.rangeSwitchList = this.jsonDataService.data.refCds.filter((e: any) => e.rvDomain=="RANGE_SW");
  }

  canDeactivate(): Observable<boolean> | boolean {
    if(this.tempAddedData!='' || this.tempUpdateData!='') {
      return false;
    } else {
      return true;
    }
  }

  deductibleTblConfig: any = {
    cols: [
      {
        key: "DEDUCTIBLE_CD",
        header: "Deductible Code",
        dataType: "string"
      },
      {
        key: "DEDUCTIBLE_TITLE",
        header: "Deductible",
        dataType: "string"
      },
      {
        key: "DEDUCTIBLE_TYPE_MEANING",
        header: "Deductible Type",
        dataType: "string"
      },
      {
        key: "DEDUCTIBLE_RATE",
        header: "Deductible Rate",
        dataType: "rateDecimal"
      },
      {
        key: "MIN_AMT",
        header: "Minimum Amount",
        dataType: "currency"
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '10%'
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }
  ngOnInit() {
  }

  initOnGet(): void {
    try {
      this.apiCallService.refreshNeeded$
            .subscribe(() => {
              this.getAllDeductible();
          });
      this.getAllDeductible();
    }
    catch(e) {
    }
  }

  async getAllDeductible(){
    try{
      let lineCd = this.paramForm.get('lineCd')?.value;
      let sublineCd = this.paramForm.get('sublineCd')?.value;
      if (lineCd && sublineCd) {
        const params = {
          queryParams:{
            lineCd: lineCd,
            sublineCd: sublineCd
          },
          moduleId: this.moduleId,
          userId: this.userDetailService.userId,
          type: "MODULE"
        }
        this.deductibleTblConfig.loading = true;
        this.apiCallService.getDeductible(params).subscribe({
          next: (data: any) => {
            this.securityService.checkRequestKeyResponse(data, ()=>{
              this.securityService.hasValidCsrfToken(data, ()=>{
                data = JSON.parse(this.jsonDataService.decrypt(data.response));
                let rawData:any = [];
                let finalData:any = [];
                if(!Array.isArray(data)){
                  rawData.push(data);
                }
                else{
                  rawData = data;
                }
                // finalData = this.populateTempData(finalData, rawData);
                if(rawData.length>0){
                  for(let item of rawData){
                    for(let deductibleTypeItem of this.deductibleTypeList){
                      if(item.DEDUCTIBLE_TYPE == deductibleTypeItem.rvLowValue){
                        item.DEDUCTIBLE_TYPE_MEANING = deductibleTypeItem.rvMeaning;
                      }
                    }
                  }
                }
                
                this.deductibleTblConfig.tblData = rawData;
                this.deductibleTblConfig.loading = false;
                this.tempAddedData = [];
                this.tempUpdateData = [];
                this.saveDisabled = this.saveChecker();  
              });
            })
          },
          error: (e: any) => {
            this.deductibleTblConfig.loading = false;
          }
        });
      } else{
        this.deductibleTblConfig.loading = true;
        this.deductibleTblConfig.tblData = [];
        this.deductibleTblConfig.loading = false;
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }catch(e){
    }
  }

  updateLine() {
    try {
      this.tranPosted = true;
      this.validateUpdate();
      if (this.validated) {
        this.updateFormTable();
      }
    }
    catch(e) {
    }
  }

  updateFormTable() {
    try {
      let tempInsertChecker = this.tempAddedData.find((line: { DEDUCTIBLE_CD:any }) => 
        line.DEDUCTIBLE_CD == this.deductibleForm.get('deductibleCd')?.value
      );
      let tempUpdateChecker = this.tempUpdateData.find((line: { DEDUCTIBLE_CD:any }) => 
        line.DEDUCTIBLE_CD == this.deductibleForm.get('deductibleCd')?.value
      );
      
      this.tableDataUpdate();
        
      // Adds Updated Data that exists in the database to an object array for updated datas
      let deductibleTypeMeaning =''
      for(let deductibleTypeItem of this.deductibleTypeList){
        if(this.deductibleForm.get('deductibleType')?.value == deductibleTypeItem.rvLowValue){
          deductibleTypeMeaning = deductibleTypeItem.rvMeaning;
        }
      }
      let fieldDeductibleRate = this.deductibleForm.get('deductibleRate')?.value?+this.deductibleForm.get('deductibleRate')?.value:null;
      let fieldMinAmt = this.deductibleForm.get('minAmt')?.value?+this.deductibleForm.get('minAmt')?.value:null;
      if(tempInsertChecker!=null && tempInsertChecker!='') {
        //this.tempUpdateData.push(this.formValueToData());
        tempInsertChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempInsertChecker.SUBLINE_CD = this.paramForm.get('sublineCd')?.value;
        tempInsertChecker.DEDUCTIBLE_CD = this.deductibleForm.get('deductibleCd')?.value;
        tempInsertChecker.DEDUCTIBLE_TITLE = this.deductibleForm.get('deductibleTitle')?.value;
        tempInsertChecker.DEDUCTIBLE_TEXT = this.deductibleForm.get('deductibleText')?.value;
        tempInsertChecker.DEDUCTIBLE_TYPE = this.deductibleForm.get('deductibleType')?.value;
        tempInsertChecker.DEDUCTIBLE_TYPE_MEANING = deductibleTypeMeaning;
        tempInsertChecker.DEDUCTIBLE_RATE = fieldDeductibleRate;
        tempInsertChecker.DEDUCTIBLE_AMT = this.deductibleForm.get('deductibleAmt')?.value;
        tempInsertChecker.MIN_AMT = fieldMinAmt;
        tempInsertChecker.MAX_AMT = this.deductibleForm.get('maxAmt')?.value;
        tempInsertChecker.RANGE_SW = this.deductibleForm.get('rangeSwitch')?.value;
        tempInsertChecker.ACTIVE_TAG = this.deductibleForm.get('activeTag')?.value;
        tempInsertChecker.REMARKS = this.deductibleForm.get('remarks')?.value;
        tempInsertChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempInsertChecker.USER_ID = this.deductibleForm.get('userID')?.value;
        tempInsertChecker.MODE = 'I';
      } 
      else if(tempUpdateChecker!=null && tempUpdateChecker!='') {
        tempUpdateChecker.LINE_CD= this.paramForm.get('lineCd')?.value;
        tempUpdateChecker.SUBLINE_CD = this.paramForm.get('sublineCd')?.value;
        tempUpdateChecker.DEDUCTIBLE_CD = this.deductibleForm.get('deductibleCd')?.value;
        tempUpdateChecker.DEDUCTIBLE_TITLE = this.deductibleForm.get('deductibleTitle')?.value;
        tempUpdateChecker.DEDUCTIBLE_TEXT = this.deductibleForm.get('deductibleText')?.value;
        tempUpdateChecker.DEDUCTIBLE_TYPE = this.deductibleForm.get('deductibleType')?.value;
        tempUpdateChecker.DEDUCTIBLE_TYPE_MEANING = deductibleTypeMeaning;
        tempUpdateChecker.DEDUCTIBLE_RATE = fieldDeductibleRate;
        tempUpdateChecker.DEDUCTIBLE_AMT = this.deductibleForm.get('deductibleAmt')?.value;
        tempUpdateChecker.MIN_AMT = fieldMinAmt;
        tempUpdateChecker.MAX_AMT = this.deductibleForm.get('maxAmt')?.value;
        tempUpdateChecker.RANGE_SW = this.deductibleForm.get('rangeSwitch')?.value;
        tempUpdateChecker.ACTIVE_TAG = this.deductibleForm.get('activeTag')?.value;
        tempUpdateChecker.REMARKS = this.deductibleForm.get('remarks')?.value;
        tempUpdateChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempUpdateChecker.USER_ID = this.deductibleForm.get('userID')?.value;
        tempUpdateChecker.MODE = 'U';
      }
      else {
        this.tempUpdateData.push(this.formValueToData());
      }
      this.saveDisabled = false;
      this.resetFormValues();
      this.appMessageService.showAppMessage("Standard Rates details updated!", "success");
    }
    catch(e) {
    }
  }

  tableDataUpdate() {
    try {
      this.deductibleForm.patchValue({
        activeTag: this.deductibleForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let updateIndex = this.deductibleTblConfig.tblData.indexOf(this.rowClickedData);
      let deductibleTypeMeaning =''
      for(let deductibleTypeItem of this.deductibleTypeList){
        if(this.deductibleForm.get('deductibleType')?.value == deductibleTypeItem.rvLowValue){
          deductibleTypeMeaning = deductibleTypeItem.rvMeaning;
        }
      }
      let fieldDeductibleRate = this.deductibleForm.get('deductibleRate')?.value?+this.deductibleForm.get('deductibleRate')?.value:null;
      let fieldMinAmt = this.deductibleForm.get('minAmt')?.value?+this.deductibleForm.get('minAmt')?.value:null;
      this.deductibleTblConfig.tblData[updateIndex] = {
        LINE_CD: this.paramForm.get('lineCd')?.value,
        SUBLINE_CD: this.paramForm.get('sublineCd')?.value,
        DEDUCTIBLE_CD: this.deductibleForm.get('deductibleCd')?.value,
        DEDUCTIBLE_TITLE: this.deductibleForm.get('deductibleTitle')?.value,
        DEDUCTIBLE_TEXT: this.deductibleForm.get('deductibleText')?.value,
        DEDUCTIBLE_TYPE: this.deductibleForm.get('deductibleType')?.value,
        DEDUCTIBLE_TYPE_MEANING: deductibleTypeMeaning,
        DEDUCTIBLE_RATE: fieldDeductibleRate,
        DEDUCTIBLE_AMT: this.deductibleForm.get('deductibleAmt')?.value,
        MIN_AMT: fieldMinAmt,
        MAX_AMT: this.deductibleForm.get('maxAmt')?.value,
        RANGE_SW: this.deductibleForm.get('rangeSwitch')?.value,
        ACTIVE_TAG: this.deductibleForm.get('activeTag')?.value,
        REMARKS: this.deductibleForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.deductibleForm.get('userID')?.value,
        MODE: 'U'
      };
      this.deductibleTblConfig.tblData = [...this.deductibleTblConfig.tblData];
    }
    catch(e) {
    }
  }

  formValueToData() {
    try {
      let deductibleTypeMeaning =''
      for(let deductibleTypeItem of this.deductibleTypeList){
        if(this.deductibleForm.get('deductibleType')?.value == deductibleTypeItem.rvLowValue){
          deductibleTypeMeaning = deductibleTypeItem.rvMeaning;
        }
      }
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        LINE_CD: this.paramForm.get('lineCd')?.value,
        SUBLINE_CD: this.paramForm.get('sublineCd')?.value,
        DEDUCTIBLE_CD: this.deductibleForm.get('deductibleCd')?.value,
        DEDUCTIBLE_TITLE: this.deductibleForm.get('deductibleTitle')?.value,
        DEDUCTIBLE_TEXT: this.deductibleForm.get('deductibleText')?.value,
        DEDUCTIBLE_TYPE: this.deductibleForm.get('deductibleType')?.value,
        DEDUCTIBLE_TYPE_MEANING: deductibleTypeMeaning,
        DEDUCTIBLE_RATE: this.deductibleForm.get('deductibleRate')?.value,
        DEDUCTIBLE_AMT: this.deductibleForm.get('deductibleAmt')?.value,
        MIN_AMT: this.deductibleForm.get('minAmt')?.value,
        MAX_AMT: this.deductibleForm.get('maxAmt')?.value,
        RANGE_SW: this.deductibleForm.get('rangeSwitch')?.value,
        ACTIVE_TAG: this.deductibleForm.get('activeTag')?.value,
        REMARKS: this.deductibleForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.deductibleForm.get('userID')?.value,
        MODE: 'U'
      }
      return formToData;
    }
    catch(e) {
    }
  }
  deleteLine() {
    try {
      let clickData = this.rowClickedData;
      this.deductibleTblConfig.tblData = this.deductibleTblConfig.tblData.filter(
        function(e: any) {
          return e.DEDUCTIBLE_CD !== clickData.DEDUCTIBLE_CD;
        }
      );
      this.tempAddedData = this.tempAddedData.filter(
        function(e: any) {

          return e.DEDUCTIBLE_CD !== clickData.DEDUCTIBLE_CD;
        }
      );
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  insertLine() {
    try {
      this.tranPosted = true;
      this.validateInsert();
      if (this.validated) {
        this.addFormToTable();
      }
    }
    catch(e) {
    }
  }
  addFormToTable() {
    try {
      this.deductibleForm.patchValue({
        activeTag: this.deductibleForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let deductibleTypeMeaning =''
      for(let deductibleTypeItem of this.deductibleTypeList){
        if(this.deductibleForm.get('deductibleType')?.value == deductibleTypeItem.rvLowValue){
          deductibleTypeMeaning = deductibleTypeItem.rvMeaning;
        }
      }
      let fieldDeductibleRate = this.deductibleForm.get('deductibleRate')?.value?+this.deductibleForm.get('deductibleRate')?.value:null;
      let fieldMinAmt = this.deductibleForm.get('minAmt')?.value?+this.deductibleForm.get('minAmt')?.value:null;
      let formToData: any = {
        LINE_CD: this.paramForm.get('lineCd')?.value,
        SUBLINE_CD: this.paramForm.get('sublineCd')?.value,
        DEDUCTIBLE_CD: this.deductibleForm.get('deductibleCd')?.value,
        DEDUCTIBLE_TITLE: this.deductibleForm.get('deductibleTitle')?.value,
        DEDUCTIBLE_TEXT: this.deductibleForm.get('deductibleText')?.value,
        DEDUCTIBLE_TYPE: this.deductibleForm.get('deductibleType')?.value,
        DEDUCTIBLE_TYPE_MEANING: deductibleTypeMeaning,
        DEDUCTIBLE_RATE: fieldDeductibleRate,
        DEDUCTIBLE_AMT: this.deductibleForm.get('deductibleAmt')?.value,
        MIN_AMT: fieldMinAmt,
        MAX_AMT: this.deductibleForm.get('maxAmt')?.value,
        RANGE_SW: this.deductibleForm.get('rangeSwitch')?.value,
        ACTIVE_TAG: this.deductibleForm.get('activeTag')?.value,
        REMARKS: this.deductibleForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.deductibleForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.deductibleForm.get('userID')?.value,
        MODE: 'I'
      }
      this.deductibleTblConfig.tblData.unshift(formToData);
      this.deductibleTblConfig.tblData = [...this.deductibleTblConfig.tblData];
      this.tempAddedData.push(formToData);
      this.resetFormValues();
      this.appMessageService.showAppMessage("Standard Rates details added!", "success");
    }
    catch(e) {
    }
  }

  saveData(tempChangeData:any[]){
    this.apiCallService.saveDeductible(tempChangeData)
    .subscribe({
      next: (response : any) => {
        this.securityService.checkRequestKeyResponse(response, () => {
          this.securityService.hasValidCsrfToken(response, ()=>{
            if (response.status == "SUCCESS" && this.tranPosted) {
              this.openDialog('SUCCESS', 'Details Successfully saved!');
              this.initOnGet();
              this.resetFormValues();
              this.tempAddedData = [];
              this.tempUpdateData = [];
              this.saveDisabled = this.saveChecker();
            }  
            else {
              this.initOnGet();
              this.saveDisabled = this.saveChecker();
              this.openDialog('ERROR', 'An error has occured while saving details');
            }
          });
        });
      }, 
      error: () => {
        this.openDialog('ERROR', 'An error has occured while saving details');
      }
    });
  }

  toSave() {
    try {
      this.noLoadingInProcess = false;
      this.formService.showFormLoader(null, "generate-line-form", "Please wait ...", null, null);
      let tempChangeData= this.tempAddedData.concat(this.tempUpdateData);
      if(tempChangeData.length!=0) {
        for(let item of tempChangeData){
          item.DEDUCTIBLE_RATE = item.DEDUCTIBLE_RATE==0?item.DEDUCTIBLE_RATE.toString():item.DEDUCTIBLE_RATE?item.DEDUCTIBLE_RATE.toString():null;
          item.MIN_AMT = item.MIN_AMT==0?item.MIN_AMT.toString():item.MIN_AMT?item.MIN_AMT.toString():null;
        }
        this.saveData(tempChangeData);
      } else {
        this.initOnGet();
        this.resetFormValues();
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }
    catch(e) {
    }
  }
  saveChecker() {
    try {
      if((this.tempAddedData==null || this.tempAddedData=='') && (this.tempUpdateData==null || this.tempUpdateData=='')) {
        return true;
      }
      else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  deleteChecker(ev: any) {
    try {
      let tempDataFlag;
      tempDataFlag = this.tempAddedData.filter(function(e: any) {
        let returnValue = e.DEDUCTIBLE_CD==ev.DEDUCTIBLE_CD
        return returnValue;
      });
      if(tempDataFlag==''||tempDataFlag==null) {
        return true;
      } else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  perilChecker(){
    try{
      let lineCd = this.paramForm.get('lineCd')?.value;
      if(lineCd!==''&&lineCd!==null){
        return false;
      }
      else{ 
        return true;
      }
    }catch(e){
      return true;
    }
  }
  onRowClick(ev: any) {
    try {    
      if(ev!=null) {
        this.rowClickedData = ev;
        this.deductibleForm.get('lineCode')?.disable();
        this.loadFormValues();
        this.saveDisabled = this.saveChecker();
        this.deleteDisabled = this.deleteChecker(ev);
      }
      else {
        this.resetFormValues();
      }
    }
    catch(e) {
    }
  }

  loadFormValues() {
    try {
      let deductibleRate: string = '';
      let deductibleAmt: string= '';
      let minAmt: string= '';
      let maxAmt: string= '';
      if(this.rowClickedData.DEDUCTIBLE_RATE!==''&&this.rowClickedData.DEDUCTIBLE_RATE!==null){
        deductibleRate = parseFloat(this.rowClickedData.DEDUCTIBLE_RATE).toFixed(9);
      }
      if(this.rowClickedData.DEDUCTIBLE_AMT!==''&&this.rowClickedData.DEDUCTIBLE_AMT!==null){
        deductibleAmt = parseFloat(this.rowClickedData.DEDUCTIBLE_AMT).toFixed(2);
      }
      if(this.rowClickedData.MIN_AMT!==''&&this.rowClickedData.MIN_AMT!==null){
        minAmt = parseFloat(this.rowClickedData.MIN_AMT).toFixed(2);
      }
      if(this.rowClickedData.MAX_AMT!==''&&this.rowClickedData.MAX_AMT!==null){
        maxAmt = parseFloat(this.rowClickedData.MAX_AMT).toFixed(2);
      }
      this.deductibleForm.patchValue({
        deductibleCd: this.rowClickedData.DEDUCTIBLE_CD,
        deductibleTitle: this.rowClickedData.DEDUCTIBLE_TITLE,
        deductibleText: this.rowClickedData.DEDUCTIBLE_TEXT,
        deductibleType: this.rowClickedData.DEDUCTIBLE_TYPE,
        deductibleRate: deductibleRate,
        deductibleAmt: deductibleAmt,
        minAmt: minAmt,
        maxAmt: maxAmt,
        rangeSwitch: this.rowClickedData.RANGE_SW,
        activeTag: this.rowClickedData.ACTIVE_TAG,
        remarks: this.rowClickedData.REMARKS,
        userID: this.rowClickedData.USER_ID,
        lastUserUpdate: this.rowClickedData.LAST_USER_UPDATE
      });
      this.addDisabled = true;
      this.userIDReadOnly = true;
      this.isLineSelected = true;
    }
    catch(e) {
    }
  }

  resetFormValues() {
    try {
      this.selectedData = null;
      // this.paramForm.get('lineCD')?.enable();
      this.deductibleForm.patchValue({
        deductibleCd: null,
        deductibleTitle: null,
        deductibleText: null,
        deductibleType: null,
        deductibleRate: null,
        deductibleAmt: null,
        minAmt: null,
        maxAmt: null,
        rangeSwitch: null,
        activeTag: 'A',
        remarks: null,
        userID: null,
        lastUserUpdate: null
      });

      this.addDisabled = false;
      this.saveDisabled = this.saveChecker();
      this.deleteDisabled = true;
      this.userIDReadOnly = false;
      this.isLineSelected = false;

      this.rowClickedData = '' || null;
    }
    catch (e) {
    console.error(e);
    }
  }

  openLineDialog() {
    try {
      this._Dialog.open(LineLovDialogComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'LINE',
          userId: this.userDetailService.userId,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedLine = data.content;
          this.paramForm.get('lineCd')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_CD);
          this.paramForm.get('lineName')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_NAME);
          this.paramForm.get('lineField')?.setValue(this.selectedLine.LINE_CD==null || this.selectedLine.LINE_CD=='' ? '' : this.selectedLine.LINE_CD + " - " + this.selectedLine.LINE_NAME);
        }
        this.paramForm.get('perilCd')?.setValue(null);
        this.paramForm.get('perilName')?.setValue(null);
        this.paramForm.get('perilField')?.setValue(null);
        this.resetFormValues();
        this.initOnGet();
        this.perilDisabled = this.perilChecker();
      });
    } catch(e) {
    }
  }
  openSublineDialog() {
    try {
      this._Dialog.open(LineLovDialogComponent, {
        width: '512px',
        disableClose: true,
        data: {
          table: 'SUBLINE',
          userId: this.userDetailService.userId,
          lineCd: this.paramForm.get('lineCd')?.value,
          moduleId: this.moduleId
        }
      }).afterClosed().subscribe(data => {
        if (data.content != '' && data.content != null) {
          this.selectedSubline = data.content;
          this.paramForm.get('sublineCd')?.setValue(this.selectedSubline.SUBLINE_CD==null || this.selectedSubline.SUBLINE_CD=='' ? '' : this.selectedSubline.SUBLINE_CD);
          this.paramForm.get('sublineName')?.setValue(this.selectedSubline.SUBLINE_CD==null || this.selectedSubline.SUBLINE_CD=='' ? '' : this.selectedSubline.SUBLINE_NAME);
          this.paramForm.get('sublineField')?.setValue(this.selectedSubline.SUBLINE_CD==null || this.selectedSubline.SUBLINE_CD=='' ? '' : this.selectedSubline.SUBLINE_CD+ " - " + this.selectedSubline.SUBLINE_NAME);
          this.initOnGet();
        }
        this.resetFormValues();
      });
    } catch(e) {
    }
  }
  openDialog(title: any, message: any) {
    try {
      this.noLoadingInProcess = true;
      this.formService.hideFormLoader("generate-line-form");
      this._Dialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
    }
  }

  populateTempData(finalData:any[], rawData:any[]){
    let lineCd = this.paramForm.get('lineCd')?.value;
    let sublineCd = this.paramForm.get('sublineCd')?.value;

    let filteredAddedData: any=[];
    let filteredUpdatedData: any=[];
    if(this.tempUpdateData!=null&&this.tempUpdateData.length!=0){
      filteredUpdatedData = this.tempUpdateData.filter(function(item:any){
        if(item.LINE_CD==lineCd&&item.SUBLINE_CD==sublineCd){
          finalData = rawData.filter(function(rawDataItem:any){
            if(rawDataItem.LINE_CD==lineCd&&rawDataItem.SUBLINE_CD==sublineCd&&rawDataItem.DEDUCTIBLE_CD==item.DEDUCTIBLE_CD){
              return false;
            }
            else{
              return true;
            }
          })
          return true;
        }
        else{
          return false;
        }
      })
      if(filteredUpdatedData.length!=0&&filteredUpdatedData!=null){
        finalData = finalData.concat(filteredUpdatedData);
      }
      else{
        finalData = rawData;
      }
    }
    else{
      finalData = rawData;
    }
    
    if(this.tempAddedData!=null&&this.tempAddedData.length!=0){
      filteredAddedData = this.tempAddedData.filter(function(item:any){
        if(item.LINE_CD==lineCd&&item.SUBLINE_CD==sublineCd){
          return true;
        }
        else{
          return false;
        }
      })
      if(filteredAddedData.length!=0&&filteredAddedData!=null){
        finalData = finalData.concat(filteredAddedData);
      }
    }
    if(finalData.length>0){
      for(let item of finalData){
        for(let deductibleTypeItem of this.deductibleTypeList){
          if(item.DEDUCTIBLE_TYPE == deductibleTypeItem.rvLowValue){
            item.DEDUCTIBLE_TYPE_MEANING = deductibleTypeItem.rvMeaning;
          }
        }
      }
    }
    return finalData;
  }
  
  validateInsert() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                           //10 secs countdown
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else if (this.rateCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else if(this.numberCheck('deductibleAmt')||this.numberCheck('minAmt')||this.numberCheck('maxAmt')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  requiredFieldCheck() {
    try {
      if(this.paramForm.get('lineCd')?.value==='' || this.paramForm.get('lineCd')?.value===null
        ||this.paramForm.get('sublineCd')?.value==='' || this.paramForm.get('sublineCd')?.value===null
        ||this.deductibleForm.get('deductibleCd')?.value.trim()==='' || this.deductibleForm.get('deductibleCd')?.value===null
        ||this.deductibleForm.get('activeTag')?.value==='' || this.deductibleForm.get('activeTag')?.value===null) {
        this.formService.showFormMsg("bfb-standard-rates-error-message", 'There are missing information. Please provide the necessary information needed.', "E");
        return false;
      }
      else {
        return true;
      }
   }
    catch (e) {
    console.error(e);
      return false;
    }
  }

  validateUpdate() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                          
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else if (this.rateCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else if(this.numberCheck('deductibleAmt')||this.numberCheck('minAmt')||this.numberCheck('maxAmt')){
        setTimeout(()=>{                           
          this.formService.hideFormMsg("bfb-standard-rates-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  duplicateCheck() {
    try {
      let deductibleCd = this.deductibleForm.get('deductibleCd')?.value
      this.pubUserStdRatesCodeField = this.deductibleTblConfig.tblData.filter(function(e: any) {
        if(e.DEDUCTIBLE_CD==deductibleCd.trim()){
          return true
        }else{
          return false
        }
      });
      if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
        return true;
      } else {
        this.formService.showFormMsg("bfb-standard-rates-error-message", 'Deductible Code already exists. Please enter a different code.', "E");
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  } 

  rateCheck(){
    let rate = parseFloat(this.deductibleForm.get('deductibleRate')?.value);
    let deductibleRate = this.deductibleForm.get('deductibleRate')?.value;
    let fieldLabel = 'Deductible Rate';
    if(deductibleRate===''||deductibleRate===null){
      return false
    }
    if(rate<0){
      this.formService.showFormMsg("bfb-standard-rates-error-message", 'Invalid value in '+fieldLabel+' field. The value entered is a negative number', "E");
      return true;
    }
    if(rate<1000){
      return false
    }
    else{
      this.formService.showFormMsg("bfb-standard-rates-error-message", 'Invalid value in '+fieldLabel+' field. The value entered exceeded the maximum limit', "E");
      return true
    }
  }

  numberCheck(fieldName:string){
    let fieldFloat = parseFloat(this.deductibleForm.get(fieldName)?.value);
    let fieldAmt = this.deductibleForm.get(fieldName)?.value;
    let fieldLabel = '';
    if(fieldName=='deductibleAmt'){
      fieldLabel = 'Deductible Amount'
    }
    else if(fieldName=='minAmt'){
      fieldLabel = 'Minimum Amount'
    }
    else if(fieldName=='maxAmt'){
      fieldLabel = 'Maximum Amount'
    }
    if(fieldAmt===''||fieldAmt===null){
      return false
    }
    if(fieldFloat<0){
      this.formService.showFormMsg("bfb-standard-rates-error-message", 'Invalid value in '+fieldLabel+' field. The value entered is a negative number', "E");
      return true;
    }
    if(fieldAmt.length>17){
      this.formService.showFormMsg("bfb-standard-rates-error-message", 'Invalid value in '+fieldLabel+' field. The value entered exceeded the maximum limit', "E");
      return true
    }
    else{
      return false
    }
  }

  deductibleRateFormat(){
    if(this.deductibleForm.get("deductibleRate")?.value!==''&&this.deductibleForm.get("deductibleRate")?.value!==null){
      let deductibleFloat =  parseFloat(this.deductibleForm.get("deductibleRate")?.value.replace(/,/g, ''))
      let deductibleRate =deductibleFloat.toFixed(9);
      if(isNaN(deductibleFloat)||deductibleRate=='NaN'){
        this.deductibleForm.get("deductibleRate")?.setValue('');
      }
      else{
        this.deductibleForm.get("deductibleRate")?.setValue(deductibleRate);
      }
    }
  }

  amtFormat(fieldName:string){
    if(this.deductibleForm.get(fieldName)?.value!==''&&this.deductibleForm.get(fieldName)?.value!==null){
      let fieldFloat = parseFloat(this.deductibleForm.get(fieldName)?.value.replace(/,/g, ''))
      let fieldAmt = fieldFloat.toFixed(2);
      if(isNaN(fieldFloat)||fieldAmt=='NaN'){
        this.deductibleForm.get(fieldName)?.setValue('');
      }
      else{
        this.deductibleForm.get(fieldName)?.setValue(fieldAmt);
      }
    }
  }
}
